import moment from 'moment';
import { isMobile } from 'react-device-detect';
import constants from '../constants';

moment.locale('es', {
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ],
  weekdays: [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado'
  ]
});
export default class DateHelpers {
  public static addDays(date: Date, days: number) {
    const copy = new Date(Number(date));
    copy.setDate(date.getDate() + days);
    return copy;
  }

  public static getPeruDate() {
    const date = new Date();
    const utcDate = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    );
    return new Date(utcDate.getTime() - constants.MIL_PERU);
  }

  public static convertToPeruDate(timestamp: number) {
    const date = new Date(timestamp);
    const utcDate = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    );
    return new Date(utcDate.getTime() - constants.MIL_PERU);
  }

  public static getFirstDayOfWeek() {
    const peruDate = DateHelpers.getPeruDate();
    peruDate.setDate(peruDate.getDate() - ((peruDate.getDay() + 6) % 7));
    peruDate.setHours(0, 0, 0, 0);
    return peruDate;
  }

  public static getFirstDayOfWeekFromTimestamp(timestamp: number) {
    const myDate = new Date(timestamp);
    myDate.setDate(myDate.getDate() - ((myDate.getDay() + 6) % 7));
    myDate.setHours(0, 0, 0, 0);
    return myDate;
  }

  public static formatDate(timestamp: number) {
    if (timestamp === null || timestamp === 0) {
      return 0;
    }
    return `${DateHelpers.getDayWithFormat(
      timestamp
    )} ${DateHelpers.getShortMonthName(
      timestamp
    )} ${DateHelpers.getYearWithFormat(timestamp)}`;
  }

  // FUNCION NUEVA
  public static formatDateExtended(timestamp: number) {
    if (timestamp === null || timestamp === 0) {
      return '';
    }

    return moment(timestamp).utc().format('dddd DD [de] MMMM');
  }

  // FUNCION PARA CARD RESERVAS
  public static extendedDate(timestamp: number) {
    if (timestamp === null || timestamp === 0) {
      return 0;
    }
    return `${DateHelpers.getDayName2(
      timestamp,
      'capitalize',
      true
    )}, ${DateHelpers.formatDateExtended2(timestamp)}`;
  }

  public static formatDateExtended2(timestamp: number, notUTC?: boolean) {
    if (timestamp === null || timestamp === 0) {
      return 0;
    }
    const dateFormat = notUTC
      ? DateHelpers.getDayWithFormat(timestamp, true)
      : DateHelpers.getUTCDayWithFormat(timestamp);
    return `${dateFormat} ${DateHelpers.getShortMonthName(
      timestamp
    ).toLowerCase()} ${DateHelpers.getYearWithFormat(timestamp)}`;
  }

  public static formatDateExtended3(timestamp: number) {
    if (timestamp === null || timestamp === 0) {
      return 0;
    }
    return `${DateHelpers.getUTCDayWithFormat(
      timestamp
    )} de ${DateHelpers.getShortMonthName(
      timestamp
    ).toLowerCase()} del ${DateHelpers.getYearWithFormat(timestamp)}`;
  }

  public static isBetweenDates(d1: any, d2: any, d3: any) {
    const dd1 = new Date(0);
    const dd2 = new Date(0);
    const dd3 = new Date(0);

    dd1.setUTCSeconds(d1);
    dd2.setUTCSeconds(d2);
    dd3.setUTCSeconds(d3);
    let isBetween = false;
    if (dd3 >= dd1 && dd3 <= dd2) {
      isBetween = true;
    }
    return isBetween;
  }

  public static getShortMonthName(timestamp: number) {
    const date = new Date(timestamp);
    const nameOfMonths = [
      'ENE',
      'FEB',
      'MAR',
      'ABR',
      'MAY',
      'JUN',
      'JUL',
      'AGO',
      'SET',
      'OCT',
      'NOV',
      'DIC'
    ];
    const monthIndex = date.getMonth();

    return nameOfMonths[monthIndex];
  }

  public static converDateToEpoch(date: Date) {
    return Math.round(new Date(date).getTime() / 1000.0);
  }

  public static getMonthName(timestamp: number) {
    const date = new Date(timestamp);
    const nameOfMonths = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'setiembre',
      'octubre',
      'noviembre',
      'diciembre'
    ];
    const monthIndex = date.getMonth();

    return nameOfMonths[monthIndex];
  }

  public static getMonthNumberForMin(value: string) {
    switch (value.toUpperCase()) {
      case 'ENE':
        return 0;
      case 'FEB':
        return 1;
      case 'MAR':
        return 2;
      case 'ABR':
        return 3;
      case 'MAY':
        return 4;
      case 'JUN':
        return 5;
      case 'JUL':
        return 6;
      case 'AGO':
        return 7;
      case 'SET':
        return 8;
      case 'OCT':
        return 9;
      case 'NOV':
        return 10;
      case 'DIC':
        return 11;
      default:
        return 0;
    }
  }

  /**
   * Formats an ISO date string into "day shortMonth year", e.g., "4 jul 2025".
   * @param dateStr ISO date string
   * @returns formatted date or undefined if invalid
   */
  public static formatDateString(dateStr?: string): string | undefined {
    if (!dateStr) return undefined;
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return undefined;
    const day = DateHelpers.padTo2Digits(d.getDate());
    const monthNames = [
      'ene',
      'feb',
      'mar',
      'abr',
      'may',
      'jun',
      'jul',
      'ago',
      'sep',
      'oct',
      'nov',
      'dic'
    ];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear();
    return `${day} ${month} ${year}`;
  }

  public static getMonthNumber(timestamp: number) {
    const date = new Date(timestamp);
    const numberOfMonths = [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12'
    ];
    const monthIndex = date.getMonth();

    return numberOfMonths[monthIndex];
  }

  public static getDayWithFormat(timestamp: number, withZero = true) {
    const date = new Date(timestamp);
    return date.getDate() <= 9 && withZero
      ? `0${date.getDate()}`
      : `${date.getDate()}`;
  }

  public static getUTCDayWithFormat(timestamp: number) {
    const date = new Date(timestamp);
    return date.getUTCDate() <= 9
      ? `0${date.getUTCDate()}`
      : `${date.getUTCDate()}`;
  }

  public static isSameDay(startTimestamp: number, endTimestamp: number) {
    const date1 = new Date(startTimestamp);
    const date2 = new Date(endTimestamp);
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  public static getYearWithFormat(timestamp: number) {
    const date = new Date(timestamp);
    return date.getFullYear();
  }

  public static getDayName2(
    timestamp: number,
    transform = 'upper', // lower, capitalize
    fullName = false
  ) {
    const date = new Date(timestamp);
    let nameOfDays = ['LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SÁB', 'DOM'];
    if (fullName) {
      nameOfDays = [
        'LUNES',
        'MARTES',
        'MIERCOLES',
        'JUEVES',
        'VIERNES',
        'SÁBADO',
        'DOMINGO'
      ];
    }
    if (isMobile) nameOfDays = nameOfDays.map((d) => d.slice(0, 1));
    const dayIndex = date.getDay() - 1;
    const name = nameOfDays[dayIndex < 0 ? 6 : dayIndex];
    if (transform === 'lower') return name.toLowerCase();
    if (transform === 'capitalize')
      return name.toUpperCase().slice(0, 1) + name.toLowerCase().slice(1);
    return name;
  }

  public static getDayName(
    timestamp: number,
    transform = 'upper', // lower, capitalize
    fullName = false
  ) {
    const date = new Date(timestamp);
    let nameOfDays = ['LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB', 'DOM'];
    if (fullName) {
      nameOfDays = [
        'LUNES',
        'MARTES',
        'MIÉRCOLES',
        'JUEVES',
        'VIERNES',
        'SÁBADO',
        'DOMINGO'
      ];
    }
    const dayIndex = date.getDay() - 1;
    const name = nameOfDays[dayIndex < 0 ? 6 : dayIndex];
    if (transform === 'lower') return name.toLowerCase();
    if (transform === 'capitalize')
      return name.toUpperCase().slice(0, 1) + name.toLowerCase().slice(1);
    return name;
  }

  public static formatHour(varDate: number) {
    const date = new Date(varDate);

    return `${date.getHours() <= 9 ? `0${date.getHours()}` : date.getHours()}:${
      date.getMinutes() <= 9 ? `0${date.getMinutes()}` : date.getMinutes()
    }`;
  }

  public static formatFullDate(date: Date) {
    const timestamp = date?.getTime();
    return `${this.getDayName(
      timestamp,
      'upper',
      false
    )}, ${this.getDayWithFormat(timestamp)} ${this.getShortMonthName(
      timestamp
    )} ${this.getYearWithFormat(timestamp)}`;
  }

  public static formatFullDate2(date: Date) {
    const timestamp = date?.getTime();
    return `${this.getDayName(
      timestamp,
      'upper',
      true
    )}, ${this.getDayWithFormat(timestamp)} ${this.getShortMonthName(
      timestamp
    )} ${this.getYearWithFormat(timestamp)}`;
  }

  public static formatFullDayAndMonth(date: Date, withYear?: boolean) {
    const timestamp = date?.getTime();
    const year = withYear ? `del ${this.getYearWithFormat(timestamp)}` : '';
    return `${this.getDayName(
      timestamp,
      'lower',
      true
    )}, ${this.getDayWithFormat(timestamp, false)} de ${this.getMonthName(
      timestamp
    )} ${year}`;
  }

  public static formatDateWhitFullMonth(timestamp: number) {
    return `${DateHelpers.getDayWithFormat(
      timestamp
    )} de ${DateHelpers.getMonthName(
      timestamp
    )} del ${DateHelpers.getYearWithFormat(timestamp)}`;
  }

  public static formatMonthDate(timestamp: number) {
    return `${DateHelpers.getMonthName(
      timestamp
    )} ${DateHelpers.getDayWithFormat(timestamp)}`;
  }

  public static readonly getNowDayNumber = () => {
    const cd = new Date(Date.now());
    const d = cd.getDay() - 1;
    return d;
  };

  public static readonly getThisDayNumber = (someDate: Date) => {
    const d = someDate.getDay();
    return d;
  };

  public static readonly dateRangeOverlaps = (
    astart: number,
    aend: number,
    bstart: number,
    bend: number
  ) => {
    if (astart <= bstart && bstart <= aend) return true; // b starts in a
    if (astart <= bend && bend <= aend) return true; // b ends in a
    if (bstart < astart && aend < bend) return true; // a in b
    return false;
  };

  public static readonly dateRangeOverlapsAcademic = (
    start: number,
    end: number,
    date: number
  ) => {
    if (start <= date && date <= end) return true; // b starts in a
    return false;
  };

  public static readonly dateRangeOverlaping = (
    start1: number,
    end1: number,
    start2: number,
    end2: number
  ) => Math.max(start1, start2) < Math.min(end1, end2);

  public static readonly checkListMatch = (arr: any[], el: boolean) => {
    let found = false;
    arr.forEach((element) => {
      if (element === el) {
        found = true;
      }
    });
    return found;
  };

  public static readonly countListMatch = (arr: any[], el: boolean) => {
    let found = 0;
    arr.forEach((element) => {
      if (element === el) {
        found += 1;
      }
    });
    return found;
  };

  public static readonly OverlapingList = (objB: any, objA: any) => {
    const MatchList = objA.filter(
      (a: any) =>
        DateHelpers.dateRangeOverlaping(a.start, a.end, objB.start, objB.end) &&
        a.eventId !== objB.eventId
    );

    return MatchList;
  };

  public static readonly OverlapingSelf = (objC: any, objD: any) => {
    const MatchList: any = [];
    if (objC.length) {
      objC.forEach((valor: any, /* indice: number, */ array: any) => {
        try {
          (array || []).forEach((element: any, ix: number) => {
            if (
              DateHelpers.dateRangeOverlaping(
                element.start,
                element.end,
                valor.start,
                valor.end
              ) &&
              element.evenId !== valor.eventId
            ) {
              MatchList.push({
                orderIndex: ix,
                order: valor.order,
                eventCross: valor,
                eventCrossAtTime: DateHelpers.OverlapingList(valor, objD)
              });
            }
          });
        } catch (e) {
          // console.log(e);
        }
      });
    }

    return MatchList;
  };

  public static readonly getGroupOfMax = (os: any) => {
    let max = 0;
    let maxGroup;
    os.forEach((e: any) => {
      if (e?.eventCrossAtTime?.length > max) {
        max = e?.eventCrossAtTime?.length ? e.eventCrossAtTime?.length : 0;
        maxGroup = e?.eventCrossAtTime ? e?.eventCrossAtTime : [];
      }
    });
    return maxGroup;
  };

  public static readonly getDayNameOfWeek = (
    idDay: number,
    fullName = false
  ) => {
    const nameOfDays = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
    const fullNameOfDays = [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo'
    ];
    return fullName ? fullNameOfDays[idDay - 1] : nameOfDays[idDay - 1];
  };

  public static padTo2Digits(num: any) {
    return num.toString().padStart(2, '0');
  }

  public static formatDateWithSlash(date: any) {
    return [
      DateHelpers.padTo2Digits(new Date(date).getDate()),
      DateHelpers.padTo2Digits(new Date(date).getMonth() + 1),
      new Date(date).getFullYear()
    ].join('/');
  }

  public static minutesToRange(
    timestampStart: number,
    timestampEnd: number,
    minutes: number
  ) {
    const result: any[] = [];

    const date = moment().utc(true);
    const start = moment(timestampStart).utc();
    const end = moment(timestampEnd).utc();
    const current = moment(timestampStart).utc();

    start.minutes(Math.ceil(start.minutes() / minutes) * minutes);
    while (current < end) {
      if (date.isBefore(current)) {
        result.push({
          timestamp: Number(current.format('x')),
          hour: current.format('HH:mm')
        });
      }
      current.add(15, 'minutes');
    }

    return result;
  }

  public static hoursToNumber(hours: number) {
    const result: any[] = [];
    Array.from(Array(hours).keys()).forEach((v) => {
      const hour = v + 1;
      result.push({
        hour,
        name: `${hour} ${hour === 1 ? 'hora' : 'horas'}`
      });
    });
    return result;
  }

  public static getMinutesSubstractFromCurrentTime(
    epochDay: number,
    startTime: string
  ) {
    const hourMinutes = startTime.split(':');
    const epochReservedTime =
      epochDay +
      Number(hourMinutes[0]) * 60 * 60 * 1000 +
      Number(hourMinutes[1]) * 60 * 1000;
    const reservedTimeDate: any = new Date(
      epochReservedTime + 1000 * 60 * 60 * 5
    );
    const currentDate: any = new Date();
    const diff = reservedTimeDate - currentDate;
    return diff / 60000;
  }

  public static periodToName(period: string) {
    const month = period.slice(3);
    const year = `${period.slice(0, 1)}0${period.slice(1, 3)}`;
    let name;
    switch (Number(month)) {
      case 1:
        name = `Verano ${year}`;
        break;
      case 2:
        name = `${year} - Ciclo 1 Marzo`;
        break;
      case 3:
      case 0:
        name = `${year} - Ciclo 2 Agosto`; // sólo por nuevas filiales
        break;
      default:
        name = '';
    }
    return name;
  }

  public static periodToName2(period: string) {
    const month = period.slice(3);
    const year = `${period.slice(0, 1)}0${period.slice(1, 3)}`;
    let name;
    switch (Number(month)) {
      case 1:
        name = `Verano ${year}`;
        break;
      case 2:
        name = `Marzo ${year}`;
        break;
      case 3:
      case 0:
        name = `Agosto ${year}`; // sólo por nuevas filiales
        break;
      default:
        name = '';
    }
    return name;
  }

  public static longUTCToFormatYMD(timestamp: number): string {
    if (timestamp <= 0) return '';
    return moment.utc(timestamp).format('YYYY-MM-DD');
  }
}
